/**
 * Associate Record
 */

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const DEFAULT_UNLINKED_RECORDS = {
  data: [],
  per_page: 20,
  total_count: 0,
}

export const AssociateRecordState = {
  associateRecord: {
    isSearching: false,
    paginationOptions: {
      page: 1,
      itemsPerPage: 20,
      sortBy: [],
      sortDesc: [],
    },
    recordId: null,
    showDialog: false,
    unassociatedRecords: {
      ...DEFAULT_UNLINKED_RECORDS,
    },
  },
}

export const AssociateRecordActions = {
  getUnassociatedRecords: async ({ commit }, req) => {
    commit('setAssociateRecordSearchLoading', true)

    return axiosRequest.
      get(`/records/${req.id}/unlinked`, { params: req.params }).
      then(({ data }) => {
        commit('setAssociateRecordUnassociatedRecords', data?.records || DEFAULT_UNLINKED_RECORDS)
        commit('setAssociateRecordSearchLoading', false)
      }).
      catch(handleError)
  },

  associateRecords: async ({ commit }, req) => {
    return axiosRequest.
      post(`/records/${req.id}/link`, { record_ids: req.recordIds }).
      then(({ data }) => {
        commit('updateRecord', { field: 'related_records', data: (data?.records || []) })
      }).
      catch(handleError)
  },

  setAssociateRecordPaginationOptions ({ commit }, options) {
    commit('setAssociateRecordPaginationOptions', options)
  },

  setShowAssociateRecordDialog ({ commit }, visible) {
    commit('setShowAssociateRecordDialog', visible)
  },

  unassociateRecord: async ({ commit }, req) => {
    return axiosRequest.
      delete(`/records/${req.sourceId}/link/${req.targetId}`).
      then(({ data }) => {
        commit('updateRecord', { field: 'related_records', data: (data?.records || []) })
      }).
      catch(handleError)
  },
}

export const AssociateRecordMutations = {
  setAssociateRecordPaginationOptions: (state, value) => {
    state.associateRecord.paginationOptions = value
  },
  setAssociateRecordSearchLoading: (state, value) => {
    state.associateRecord.isSearching = value
  },
  setAssociateRecordUnassociatedRecords: (state, value) => {
    state.associateRecord.unassociatedRecords = value
  },
  setOnAssociateRecord: (state, payload) => {
    state.associateRecord.recordId = payload.recordId
    state.associateRecord.showDialog = payload.showDialog
  },
  setShowAssociateRecordDialog: (state, payload) => {
    state.associateRecord.showDialog = payload
  },
}

export const AssociateRecordGetters = {
  paginationOptionsAssociateRecord: state => state.associateRecord.paginationOptions,
  recordIdAssociateRecord: state => state.associateRecord.recordId,
  showDialogAssociateRecord: state => state.associateRecord.showDialog,
  unassociatedRecords: state => state.associateRecord.unassociatedRecords,
}
